<template>
  <SkeletonLoader>
    <div class="aging-skeleton">
      <!-- Header: title -->
      <div class="aging-skeleton__header">
        <div class="sk-line sk-line--title" style="width: 35%;"></div>
      </div>

      <!-- Tab bar: 3 tabs -->
      <div class="aging-skeleton__tabs">
        <div
          v-for="i in 3"
          :key="'tab-' + i"
          class="sk-rect"
          :style="{ width: tabWidths[i], height: '36px', borderRadius: '6px' }"
        ></div>
      </div>

      <!-- Filter bar: 2 inputs + 1 button -->
      <div class="aging-skeleton__filters">
        <div class="aging-skeleton__filter-inputs">
          <div class="sk-rect" :style="{ width: filterInputWidths[1], height: '38px', borderRadius: '6px' }"></div>
          <div class="sk-rect" :style="{ width: filterInputWidths[2], height: '38px', borderRadius: '6px' }"></div>
        </div>
        <div class="sk-rect" style="width: 120px; height: 38px; border-radius: 6px; flex-shrink: 0;"></div>
      </div>

      <!-- Table -->
      <div class="aging-skeleton__table">
        <!-- Table header -->
        <div class="aging-skeleton__table-header">
          <div
            v-for="c in 6"
            :key="'th-' + c"
            class="aging-skeleton__table-cell"
            :class="{ 'aging-skeleton__table-cell--hide-mobile': c > 3 }"
          >
            <div class="sk-line sk-line--sm" :style="{ width: headerWidths[c] }"></div>
          </div>
        </div>

        <!-- Table data rows -->
        <div
          v-for="r in 8"
          :key="'row-' + r"
          class="aging-skeleton__table-row"
        >
          <div
            v-for="c in 6"
            :key="'cell-' + r + '-' + c"
            class="aging-skeleton__table-cell"
            :class="{ 'aging-skeleton__table-cell--hide-mobile': c > 3 }"
          >
            <div class="sk-line" :style="{ width: cellWidths[r][c] }"></div>
          </div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue';

export default {
  name: 'AgingSkeleton',
  components: { SkeletonLoader },
  data() {
    return {
      tabWidths: {
        1: '150px',
        2: '100px',
        3: '140px'
      },
      filterInputWidths: {
        1: '220px',
        2: '180px'
      },
      headerWidths: {
        1: '70%',
        2: '60%',
        3: '50%',
        4: '65%',
        5: '55%',
        6: '45%'
      },
      cellWidths: {
        1: { 1: '80%', 2: '55%', 3: '60%', 4: '50%', 5: '45%', 6: '65%' },
        2: { 1: '65%', 2: '70%', 3: '45%', 4: '60%', 5: '55%', 6: '50%' },
        3: { 1: '75%', 2: '50%', 3: '55%', 4: '70%', 5: '40%', 6: '60%' },
        4: { 1: '60%', 2: '65%', 3: '70%', 4: '45%', 5: '60%', 6: '55%' },
        5: { 1: '70%', 2: '45%', 3: '65%', 4: '55%', 5: '50%', 6: '70%' },
        6: { 1: '55%', 2: '75%', 3: '50%', 4: '65%', 5: '70%', 6: '45%' },
        7: { 1: '80%', 2: '60%', 3: '55%', 4: '50%', 5: '65%', 6: '60%' },
        8: { 1: '65%', 2: '50%', 3: '70%', 4: '60%', 5: '45%', 6: '55%' }
      }
    };
  }
}
</script>

<style lang="scss" scoped>
.aging-skeleton {
  padding: 20px;
}

.aging-skeleton__header {
  margin-bottom: 20px;
}

.aging-skeleton__tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 12px;
}

.aging-skeleton__filters {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
}

.aging-skeleton__filter-inputs {
  display: flex;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.aging-skeleton__table {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.aging-skeleton__table-header {
  display: flex;
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
}

.aging-skeleton__table-row {
  display: flex;
  border-bottom: 1px solid #f1f5f9;

  &:last-child {
    border-bottom: none;
  }
}

.aging-skeleton__table-cell {
  flex: 1;
  padding: 12px 16px;
  min-width: 0;

  .sk-line {
    margin-bottom: 0;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .aging-skeleton {
    padding: 12px;
  }

  .aging-skeleton__tabs {
    flex-wrap: wrap;
  }

  .aging-skeleton__filters {
    flex-direction: column;
    align-items: stretch;
  }

  .aging-skeleton__filter-inputs {
    flex-direction: column;
  }

  .aging-skeleton__filter-inputs .sk-rect {
    width: 100% !important;
  }

  .aging-skeleton__table-cell--hide-mobile {
    display: none;
  }
}
</style>
